declare global {
    interface Window {
      ym: (...args: any[]) => void;
    }
}

export const sendMetriks = (type: string, value: string) => {
  window.ym(97900944, type, value);
}